import { LENDER_ID } from "../../../configs/constants";
export const show2ndCheckBox = (lenderId) => {
    switch (lenderId.toLowerCase()) {
        case LENDER_ID.TATA:
            return true;
            break;
        case LENDER_ID.MIRAE:
            return true;
            break;
        case LENDER_ID.BAJAJ:
            return false;
            break;
        case LENDER_ID.DSP:
            return true;
            break;
    }
    return false;
};
